export enum NotificationTypes {
  SUCCESS,
  ERROR,
}

export enum FormStage {
  ONE,
  TWO,
  THREE,
}

export enum Action {
  CREATE,
  UPDATE,
  DELETE,
}

export enum Group {
  TRANSPORT = 'transport',
  CARGO = 'cargo',
  SLOT = 'slot',
  USER = 'user',
  AVATAR = 'avatar',
  PRICES = 'prices',
  SUPPORT = 'support',
  ITEM = 'item',
  CATEGORY = 'category',
  CLUSTER = 'cluster',
  STORE = 'store',
  PROMO = 'promo',
}

export enum Status {
  NEW,
  IN_WORK,
  COMPLETED,
  POSTPONED,
  CANCELED,
  DISRUPTED,
  ARCHIVED,
  DELETED,
}

export enum CommonModals {
  LOGIN,
  PAYMENT,
  STATUS_MENU,
  CHAT_MENU,
  FILTER,
  SORT,
  LOADER,
}

export enum YooKassaStage {
  WIDGET,
  SUCCESS,
  ERROR,
}

export enum FilterDataMessage {
  SLOT = 'filterSlot',
  CARGO = 'filterCargo',
  TRANSPORT = 'filterTransport',
}
export enum FilterNames {
  SLOT = 'slotFilters',
  CARGO = 'cargoFilters',
  TRANSPORT = 'transportFilters',
  SLOT_MY = 'slotFiltersMy',
  CARGO_MY = 'cargoFiltersMy',
  TRANSPORT_MY = 'transportFiltersMy',
  SLOT_SELECTED = 'slotFiltersSelected',
  CARGO_SELECTED = 'cargoFiltersSelected',
  TRANSPORT_SELECTED = 'transportFiltersSelected',
}

export enum ChatScreens {
  LIST,
  WINDOW,
  BLOCKED,
}

export enum TopicScreens {
  ARCHIVED,
  UN_ARCHIVED,
}

export enum AfterActions {
  SHOW_CHAT = 'show_chat',
  START_CHAT = 'start_chat',
  PAYMENT = 'payment',
}

export enum TransportLoadCapacities {
  ZERO_POINT_FIVE,
  ONE,
  ONE_POINT_FIVE,
  THREE,
  FIVE,
  TEN,
  TWENTY,
  THIRTY,
  THIRTY_FIVE,
  FORTY,
  TWENTY_FIVE,
}

export enum TransportSideTypes {
  OPEN_SIDE,
  AWING,
  HARD_TOP,
  TIMBER_TRUCK,
  TANK,
  DUMP_TRUCK,
  THERMO_VAN,
  REFRIGERATOR_MINUS,
  REFRIGERATOR_PLUS,
  TOW_TRUCK,
  MIXER,
  CAR_TRANSPORTER,
  GRAIN_CARRIER,
}

export enum TransportTypes {
  SCOOTER,
  CAR,
  COMBI_CAR,
  MINIBUS,
  TRUCK,
}

export enum EquipmentTypes {
  THERMO_BAG,
  HYDRAULIC_PLATFORM,
  SIDE_LOADING,
  GLASS_STAND,
  MANIPULATOR,
}

export enum CargoTypes {
  FRAGILE,
  FOOD,
  ELECTRONICS,
  CLOTHES,
  MIXED,
  READY_FOOD,
  LUMBER,
  ROLLED_METAL,
  VEGETABLES_FRUITS,
  BULK,
  WOOD,
  BUILDING_MATERIALS,
  SPARE_PARTS,
  GRAIN,
}

export enum ListPageType {
  MY = 'my',
  SELECTED = 'selected',
}

export enum ClusterTypes {
  FOOD, // 0 - Кафе, рестораны
  FLOWERS, // 1 - Цветы
  DIY, // 2 - Стройматериалы
  CLOTHES, // 3 - Одежда
  FURNITURE, // 4 - Мебель
  DOORS, // 5 - Двери
  DEALER, // 6 - Автосалон, автозапчасти
  OIL, // 7 - Масла
  COSMETICS, // 8 - Косметика
  HOTEL, // 9 - Отель
  BEAUTY_SALON, // 10 - Салон красоты
  MEDICINE, // 11 - Медицина
  PHOTO_STUDIO, // 12 - Фотостудия
  AUTO_PARTS, // 13 - Автозапчасти
  // Услуги — только когда появится конкретный клиент:
  // NAILS = 'NAILS',      // Маникюр
  // CLEANING = 'CLEANING', // Клининг
  // REPAIR = 'REPAIR',     // Ремонт техники
}

export enum FieldType {
  NOT_SELECTED = -1,
  INPUT,
  SELECT,
  MULTISELECT,
  CHECKBOX,
}

export enum ValueType {
  NOT_SELECTED = -1,
  STRING,
  NUMBER,
  BOOLEAN,
  DATE,
}

export enum Unit {
  NOT_SELECTED = -1,
  GRAM,
  KILOGRAM,
  TON,
  MILLILITER,
  LITER,
  PIECE,
  CENTIMETER,
  METER,
  MINUTE,
  HOUR,
  DAY,
  MONTH,
  YEAR,
  PORTION,
  EMPTY,
}

export enum SaleItemFormView {
  FORM = 'form',
  ATTRIBUTE = 'attribute',
  GROUP = 'group',
  ADDONS = 'addons',
  RECOMMENDATIONS = 'recommendations',
  AVAILABILITY = 'availability',
  KIT = 'kit',
}

export enum ClusterFormView {
  FORM,
  DELIVERY,
  BONUS,
  PAYMENT,
  TARIFF,
  CDEK,
}

export enum OrderStatus {
  NEW,
  PREPARING,
  DELIVERING,
  DELIVERED,
  PICKED_UP,
  CANCELLED,
  READY,
}

export enum DeliveryType {
  UNSET = -1,
  DELIVERY,
  PICKUP,
}

export enum PaymentMethod {
  UNSET = -1,
  CARD_ON_DELIVERY,
  CASH_ON_DELIVERY,
  ONLINE,
}

export enum PaymentStatus {
  PENDING,
  PAID,
  FAILED,
  REFUNDED,
}

export enum RuleType {
  DISCOUNT,
  DELIVERY,
  BONUS,
  PROMO_CODE,
}

export enum ConditionType {
  MIN_ORDER_AMOUNT,
  PROMO_CODE,
  TIME_RANGE,
  PRODUCT_IN_CATEGORY,
  DAY_OF_WEEK,
}

export enum ActionType {
  PERCENTAGE_DISCOUNT,
  FIXED_DISCOUNT,
  SET_DELIVERY_COST,
  FREE_DELIVERY,
  ADD_BONUS_POINTS,
  USE_BONUS_POINTS,
}

export enum RuleFormView {
  BASIC,
  CONDITIONS,
  ACTION,
}

export enum StockDocumentType {
  RECEIPT, // 0 - приход
  WRITE_OFF, // 1 - списание
  INVENTORY, // 2 - инвентаризация
  MOVE, // 3 - перемещение
}

export enum StoreFormView {
  MAIN,
  DELIVERY,
}

export enum PriceDocumentType {
  INIT, // 0 - первичная загрузка
  SYNC, // 1 - синхронизация
  MANUAL, // 2 - ручное изменение
  IMPORT, // 3 - импорт из файла
  CALCULATION, // 4 - пересчет/акция
}

export enum StoreType {
  FOOD_DARK_STORE,
  GOODS_DARK_STORE,
  RESTAURANT,
  FAST_FOOD,
  FLOWERS_SHOP,
}

export enum LegalEntityType {
  INDIVIDUAL, // Индивидуальный предприниматель
  LLC, // Общество с ограниченной ответственностью
  JSC, // Акционерное общество
  SOLE, // Самозанятый
  OTHER, // Другое
  UNSET = -1,
}

export enum SystemType {
  MODIFIERS = 'modifiers', // категория для добавок
  PROMO = 'promo', // категория для акционных товаров
  HIDDEN = 'hidden', // скрытая категория (только для служебных товаров)
  KIT = 'kit', // категория для комплектов
}

export enum AuthPrimary {
  TELEGRAM,
  EMAIL,
  MAX,
}

export enum EmailStage {
  EMAIL_INPUT, // 0
  CODE_INPUT, // 1
  DONE, // 2
  ERROR, // 3
}

export enum BannerVariant {
  BASE,
  SPLIT,
  EXPANDED,
  COMPACT,
  HERO,
}

export enum LeadFormStage {
  FILL,
  SUCCESS,
  ERROR,
  PROGRESS,
}

// common/types/enums.ts

export enum CategoryFieldType {
  NONE = -1,
  STRING = 0,
  NUMBER = 1,
  TEXT = 2,
  DATE = 3,
  BOOLEAN = 4,
}

export enum ComplexOrderStatus {
  DRAFT = 0,
  SENT_TO_MANAGER = 1,
  IN_PROGRESS = 2,
  APPROVED = 3,
  CONVERTED = 4,
  ARCHIVED = 5,
}

export enum DeliveryService {
  CDEK = 'cdek',
  DELLIN = 'dellin',
  PEK = 'pek',
  CUSTOM = 'custom',
}

export enum DeliveryStatus {
  CREATED = 'CREATED',
  IN_TRANSIT = 'IN_TRANSIT',
  READY_FOR_PICKUP = 'READY_FOR_PICKUP',
  DELIVERED = 'DELIVERED',
  NOT_DELIVERED = 'NOT_DELIVERED',
  RETURNED = 'RETURNED',
  CANCELLED = 'CANCELLED',
}

export enum CatUploadStatus {
  PENDING = 'pending',
  PROCESSING = 'processing',
  SUCCESS = 'success',
  ERROR = 'error',
}

export enum EntityType {
  CLUSTER = 1,
  STORE = 2,
  CATEGORY = 3,
  ITEM = 4,
  EXECUTOR = 5,
  MOTIVATION = 6,
  PLACE = 7,
  BOOKING = 8,
  ORDER = 9,
  COMPLEX_ORDER = 10,
  PROMO = 11,
  STOCK = 12,
  PRICE = 13,
  STOCK_DOCUMENT = 14,
  PRICE_DOCUMENT = 15,
}

export enum TaskStatus {
  PENDING = 0,
  TAKEN = 1,
  IN_PROGRESS = 2,
  ARRIVED = 3,
  DELIVERED = 4,
  CANCELLED = 5,
}

export enum TaskType {
  DELIVERY = 0,
  SALE = 1,
  SERVICE = 2,
}

export enum TaskFilter {
  POOL = 'pool',
  MY = 'my',
  HISTORY = 'history',
}

